import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';
import { useScrollReveal } from '../hooks/useScrollReveal';

function FAQItem({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid={`faq-item-${index}`}
      className="border-b border-white/5"
    >
      <button
        onClick={() => setOpen(!open)}
        data-testid={`faq-toggle-${index}`}
        className="w-full flex items-center justify-between py-6 text-left group"
      >
        <span className="font-sora font-medium text-white text-base group-hover:text-exevori-primary transition-colors pr-4">
          {item.q}
        </span>
        <ChevronDown
          size={20}
          className={`text-gray-400 flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180 text-exevori-primary' : ''}`}
        />
      </button>
      <div
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? '500px' : '0', opacity: open ? 1 : 0 }}
      >
        <div className="pb-6 pr-8">
          <p className="text-gray-300 font-inter leading-relaxed">{item.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQPage() {
  const { lang } = useLang();
  const tr = t[lang];
  const fTr = tr.faqPage;
  const [ref, visible] = useScrollReveal();

  return (
    <main data-testid="faq-page">
      {/* Hero */}
      <section className="pt-32 pb-16 relative" style={{ backgroundColor: '#0D1F1F' }}>
        <div
          className="absolute inset-0 opacity-20"
          style={{ backgroundImage: 'radial-gradient(circle at 40% 50%, rgba(79,142,247,0.4) 0%, transparent 50%)' }}
        />
        <div className="section-container relative text-center max-w-2xl mx-auto">
          <h1 className="font-sora font-black text-4xl sm:text-5xl text-white mb-3 animate-fadeInUp">
            {fTr.hero.title}
          </h1>
          <div className="w-14 h-0.5 gradient-bg rounded-full mx-auto mb-6" />
          <p className="text-gray-300 text-base md:text-lg font-inter animate-fadeInUp delay-100">
            {fTr.hero.subtitle}
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24" style={{ backgroundColor: '#0A1A1A' }}>
        <div className="section-container">
          <div ref={ref} className={`max-w-3xl mx-auto reveal ${visible ? 'visible' : ''}`}>
            <div className="exevori-card px-8 py-2">
              {fTr.items.map((item, i) => (
                <FAQItem key={i} item={item} index={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Still questions CTA */}
      <section className="py-20" style={{ backgroundColor: '#0D1F1F' }}>
        <div className="section-container text-center">
          <h2 className="font-sora font-bold text-2xl text-white mb-4">
            {lang === 'fr' ? 'Vous n\'avez pas trouvé la réponse ?' : 'Didn\'t find your answer?'}
          </h2>
          <p className="text-gray-300 font-inter mb-8">
            {lang === 'fr'
              ? 'Contactez-nous directement et nous vous répondrons dans les plus brefs délais.'
              : 'Contact us directly and we will get back to you as soon as possible.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" data-testid="faq-contact-cta" className="btn-primary">
              {tr.nav.contact} <ArrowRight size={16} />
            </Link>
            <Link to="/devis" data-testid="faq-quote-cta" className="btn-secondary">
              {tr.nav.quote}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
